exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".page-header{background-color:#000;background-repeat:no-repeat;box-shadow:1px 3px 2px 0 #a5a2a2;background-size:cover;background-position:50%;border:0;margin:0 auto;padding:0;position:relative}.profile_page{background-image:none}span.span-td{font-size:10px;color:#828282}", ""]);

// exports
